var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "list-wrapper" }, [
    _c(
      "div",
      { staticClass: "header" },
      [
        _c("van-icon", {
          attrs: { name: "arrow-left", size: "20", color: "#fff" },
          on: { click: _vm.goBack }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c("iframe", { attrs: { scrolling: "no", src: _vm.url, frameborder: "0" } })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a7aa37c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a7aa37c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/livevod/index.vue
// module id = null
// module chunks = 